import { useEffect, useRef } from "react";
import { clueHeading } from "@/daily/game";
import { dt } from "@/daily/strings";
import { DailyClue } from "@/daily/types";
import { ClueIcon } from "./icons";

interface ClueDialogProps {
  clue: DailyClue;
  number: number;
  onClose: () => void;
}

// The clue in full: the fact as a headline and a plain sentence of detail.
// Opens when a clue pill or label is tapped.
export const ClueDialog = ({ clue, number, onClose }: ClueDialogProps) => {
  const closeButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeButton.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div
      className="ds-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="ds-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ds-dialog-title"
      >
        <span className="ds-dialog__icon">
          <ClueIcon type={clue.type} size={26} />
        </span>
        <div className="ds-dialog__heading">
          <span className="ds-eyebrow ds-eyebrow--red">
            {clueHeading(number, clue.type)}
          </span>
          <h2 id="ds-dialog-title" className="ds-dialog__title">
            {clue.title}
          </h2>
        </div>
        <p className="ds-dialog__detail">{clue.detail}</p>
        <button
          ref={closeButton}
          type="button"
          className="ds-button ds-button--navy"
          onClick={onClose}
        >
          {dt("back")}
        </button>
      </div>
    </div>
  );
};
